/**
 * ShoppingCart Queries
 */
import gql from 'graphql-tag'

export const getTeamDesignTotal = gql`
  query getTeamDesignTotal($teamStoreItemId: String!) {
    getTeamDesignTotal(teamStoreItemId: $teamStoreItemId) {
      total
    }
  }
`

export const verifyTeamStoreQuery = gql`
  query verifyTeamStore($shortId: String!) {
    verifyTeamStore(shortId: $shortId) {
      cutoff_date
      on_demand_mode
      enabled
      closed
      gracePeriod: grace_period
      alreadyHave: already_have
    }
  }
`

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      reseller {
        status
        currency
        comission
        inline
        paypalAccount: paypal_account
      }
    }
  }
`

export const getProductQuery = gql`
  query GetProductByID($id: Int!) {
    product(id: $id, onlyActive: false) {
      id
      mpn
      upgradeOne: upgrade_one {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
      upgradeTwo: upgrade_two {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
      upgradeThree: upgrade_three {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
    }
  }
`

export const getProductPriceRangeQuery = gql`
  query getProductPriceRange($id: Int!) {
    getProductPriceRange(id: $id) {
      price
      quantity
      abbreviation
      shortName: short_name
    }
  }
`

export const getDesignVariables = gql`
  query GetDesignVariables($id: String!) {
    designVariables: getDesignVariables(id: $id) {
      id
      variableOne: variable_one
      variableTwo: variable_two
      oneLength: variable_one_length
      twoLength: variable_two_length
      variableOneCaps: variable_one_caps
      variableTwoCaps: variable_two_caps
    }
  }
`

export const getDesignLabInfo = gql`
  query getDesignLabInfo {
    profileData: getUserProfile {
      userProfile {
        country_code
      }
      reseller {
        inline
        status
      }
    }
  }
`

export const getDesignLabInfoDelivery = gql`
  query getDesignLabInfo($teamStoreId: String) {
    deliveryDate: getDeliveryDate(teamStoreId: $teamStoreId)
  }
`

export const getUpsellDataQuery = gql`
  query getUpsellItems {
    upsellItems: getUpsellItems {
      id
      code
      yotpoId: yotpo_id
      name
      onlyProDesign: only_pro_design
      active
      type: name
      description: short_description
      customizable: design_center
      retailMen: men_retail
      retailWomen: women_retail
      evo
      category_id
      categoryName: category_name
      genders {
        id
        name: gender
      }
      priceRange {
        quantity
        price
        abbreviation
        shortName: short_name
      }
      images: pictures {
        front: front_image
        genderId: gender_id
        color_id
        thumbnail
        preview
      }
      colors {
        id
        name
        image
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ShoppingCartPage/data.ts